import type { Configuration } from '@azure/msal-browser';

export function isAzureAuthConfigured(): boolean {
  const isStubAuth = process.env.REACT_APP_AUTH_STUB === 'true';
  if (isStubAuth) {
    return false;
  }

  return Boolean(
    process.env.REACT_APP_AZURE_CLIENT_ID?.trim() &&
      process.env.REACT_APP_AZURE_TENANT_ID?.trim()
  );
}

export function getMsalConfiguration(): Configuration {
  const clientId = process.env.REACT_APP_AZURE_CLIENT_ID?.trim();
  const tenantId = process.env.REACT_APP_AZURE_TENANT_ID?.trim();
  const redirectUri =
    process.env.REACT_APP_AZURE_REDIRECT_URI?.trim() ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  if (!clientId || !tenantId) {
    throw new Error(
      'MSAL: REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_TENANT_ID are required when Azure auth is enabled.'
    );
  }

  return {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
    },
    cache: {
      // localStorage (vs sessionStorage) keeps the account + refresh token across full-page
      // reloads and lets `acquireTokenSilent` renew via a first-party fetch to the token endpoint.
      // sessionStorage forces hidden-iframe renewal, which browsers block via third-party-cookie
      // policies on Static Web Apps, throwing InteractionRequired and driving a sign-in loop.
      cacheLocation: 'localStorage',
    },
  };
}
